/* eslint-disable import/prefer-default-export */
import { ILoginState } from '.'
import { RootStore } from '../store'

export const selectLogin = (state: RootStore): ILoginState => state.login
